// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__AYGyQ","desktop-spacer":"Navbar_desktop-spacer__3jF-_"};